export default __webpack_public_path__ + "static/about-categories-3b6bfb28d582dcbedce2804ee6b23db7.png";